// https://logcollectzx.aixuexi.com/collect/log/multi/v2/online_test?strict=false
import axios from 'axios'
import { getUserId } from '@/utils/tools'
export async function kibanaLog(eventLevel, events) {
  // 只生产上报
  // if (process.env.NODE_ENV !== 'production') {
  //   return
  // }
  const eventCommon = {
    // eventType: 'sdkImport',
    userId: Number(getUserId()),
    timestamp: new Date().getTime(),
    // eventId: 'common-nav',
    // eventName: '公共导航加载1111',
    eventLevel,
    referrer: document.referrer,
    url: location.href
  }
  events = events.map(ev => ({
    ...ev,
    ...eventCommon
  }))
  return axios.post(
    'https://logcollectzx.aixuexi.com/collect/log/multi/v2/online_test?strict=false',
    {
      appId: 'xkhTeacher',
      businessId: 'xkhTeacherError',
      common: {
        ua: navigator.userAgent
      },
      event: events
    }
  )
}

export async function kibanaErrorLog(events) {
  return kibanaLog('error', events)
}
export async function kibanaInfoLog(events) {
  return kibanaLog('info', events)
}